module.exports = __webpack_public_path__ + "img/icon_mid_autumn_pack.c58dd3f3.gif";